import axios from "axios";
import {WRO} from "@/env";

export default {

    /**
     * Check user is paid or no,
     * @param,
     * @api {GET}
     * @param user_id
     */
    check_if_user_paid(user_id) {
        const options = {
            method: 'GET',
            url: WRO + 'api/web/getPayments',
            headers: {'content-type': 'application/json'},
            params: user_id
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response)
                })
        })
    },

}